import { Route, Redirect } from 'react-router-dom';

function RedirectRoute({ children, userAuth, ...rest }) {
  return <Route {...rest} render={() => (userAuth !== '' ? <Redirect to="/" /> : children)} />;
}

export default RedirectRoute;
